import { api } from '@services';
import { Currency } from '@models';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/MAINBOARD') => `${reducer}/${actionType}`;

export const getCurrencyList = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const list = Currency.getList(res.info?.products || [], 'SYMBOL');

			const filteredList = list
				.filter((item) => item?.SYMBOL !== 'IRR')
				.sort((prev, next) => prev.ORDERNUM - next.ORDERNUM);
			// .slice(0, 10);

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					$currencyList: list,
					filteredCurrencyList: filteredList,
					changedTime: res.info.TIME ?? '',
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					$currencyList: [],
					filteredCurrencyList: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					_currencyList: status,
				},
			});
		};

		api.$product_fetch_mainboard({ onOK, onFail, onStatus }, { type: 'C' });
	};
};

export const getCoinList = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const list = Currency.getList(res.info?.products || [], 'SYMBOL');

			const filteredList = list
				.filter((item) => item?.SYMBOL !== 'IRR')
				.sort((prev, next) => prev.ORDERNUM - next.ORDERNUM);
			// .slice(0, 10);

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					$coinList: list,
					filteredCoinList: filteredList,
					changedTime: res.info.TIME ?? '',
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					$coinList: [],
					filteredCoinList: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					_coinList: status,
				},
			});
		};

		api.$product_fetch_mainboard({ onOK, onFail, onStatus }, { type: 'O' });
	};
};

export const getReferredList = () => {
	return async (dispatch, getState) => {
		const onOK = async (res) => {
			const list = Currency.getList(res.info?.products || [], 'SYMBOL');

			const filteredList = list
				.filter((item) => item?.SYMBOL !== 'IRR')
				.sort((prev, next) => prev.ORDERNUM - next.ORDERNUM);
			// .slice(0, 10);

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					$referredList: list,
					filteredReferredList: filteredList,
					changedTime: res.info.TIME ?? '',
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					$referredList: [],
					filteredReferredList: [],
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().organism.mainBoard,
					_referredList: status,
				},
			});
		};

		api.$product_fetch_mainboard({ onOK, onFail, onStatus }, { type: 'H' });
	};
};
